import { createApiHook } from '../hooks';
import { operationsApiFactory } from './operationsApiFactory';

export const useOperationsApi = createApiHook(operationsApiFactory);
